var shortMonth = ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
export function getFormattedDate(date) {
  var now = new Date();

  if (now.getDate() === date.getDate() && now.getFullYear() === date.getFullYear() && now.getMonth() === date.getMonth()) {
    return 'Сегодня';
  }

  return "".concat(date.getDate(), " ").concat(shortMonth[date.getMonth()], " ").concat(date.getFullYear());
}